module.exports = __webpack_public_path__ + "static/media/downArrow.a2702f5b.svg";